import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHead from "./SectionHead";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const [sent, setSent] = useState(false);

  return (
    <section id="faq" className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px]">
        <div>
          <SectionHead
            eyebrow="可信度与核实说明"
            accent
            title="关于状态判定，你需要知道的几件事"
            desc="这页把『如何核实、为什么反复、碰到实锤怎么判断』讲清楚——信任建立在可见的判定标准上，而不是一句口号。"
          />

          <div className="mt-6 overflow-hidden rounded-lg border border-background-200/70">
            {faqs.map((f, i) => {
              const on = open === i;
              return (
                <div key={i} className={i !== faqs.length - 1 ? "border-b border-background-200/60" : ""}>
                  <button
                    type="button"
                    onClick={() => setOpen(on ? null : i)}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        on ? "bg-accent-500 text-background-950" : "bg-background-200 text-foreground-500"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-heading text-sm font-bold text-foreground-950 md:text-[15px]">
                      {f.q}
                    </span>
                    <i
                      className={`text-lg text-foreground-500 transition-transform ${on ? "ri-subtract-line" : "ri-add-line"}`}
                    />
                  </button>
                  {on && (
                    <div className="px-5 pb-4 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <aside className="flex flex-col gap-4">
          <div className="rounded-lg border border-background-200/70 bg-background-100/50 p-5">
            <div className="flex items-center gap-2 text-foreground-900">
              <i className="ri-shield-check-line text-lg text-accent-400" />
              <span className="font-heading text-sm font-bold">我们的核实原则</span>
            </div>
            <ul className="mt-3 space-y-3 text-xs leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-400" />
                单方说法一律标注来源，不把「网传」当「实锤」。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-400" />
                当事人回应与平台声明并列呈现，保留对照空间。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-400" />
                状态随新信息更新并留存版本，追溯每次修正。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-400" />
                关键结论尽量附可回溯的一手素材或公开口径。
              </li>
            </ul>
          </div>

          <div className="rounded-lg border border-primary-500/30 bg-primary-500/10 p-5">
            <div className="flex items-center gap-2 text-primary-300">
              <i className="ri-feedback-fill text-lg" />
              <span className="font-heading text-sm font-bold">发现口径要更新？</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              如果你手上有可回溯的新线索，或认为某条状态标错了，欢迎通过下方按钮发给我们核对（本页为示意入口）。
            </p>
            <button
              type="button"
              onClick={() => setSent(true)}
              className="mt-3 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-mail-send-line text-base" />
              提交线索 / 纠错
            </button>
            {sent && (
              <p className="mt-3 flex items-center gap-1.5 rounded-md bg-background-200/50 px-3 py-2 text-[11px] text-secondary-300">
                <i className="ri-check-line" /> 已收到你的意图（示意入口，暂未接入真实提交）。
              </p>
            )}
          </div>
        </aside>
      </div>
    </section>
  );
}